import { AxiosResponse } from "axios";
import { call, put } from "redux-saga/effects";
import api from "../../Axios/middleware";
import {
    failureGetTutorCourses,
    successGetTutorCourses
} from "./TutorCoursesSlice";

const GetTutorCoursesApi = () => {
    return api.get(`/api/my-course/tutor/courses`);
};

// Saga to handle fetching tutor courses
export function* TutorCoursesCall() {
    try {
        const response: AxiosResponse = yield call(GetTutorCoursesApi);
        if (response.data.status) {
            yield put(successGetTutorCourses(response.data));
        } else {
            yield put(failureGetTutorCourses(response.data.message));
        }
    } catch (error: any) {
        yield put(failureGetTutorCourses(error.response?.data || error.message));
    }
}
